import { render } from "./VolunteerAvailabilities.view.vue?vue&type=template&id=1aca804c"
import script from "./VolunteerAvailabilities.view.vue?vue&type=script&lang=js"
export * from "./VolunteerAvailabilities.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__